import {
  WithLoading,
  WithLoadingProps
} from 'presentation/shared/components/HOCs/WithLoading'
import React, { useState } from 'react'
import * as S from './styles'
import Modal from 'presentation/hospital/components/Modal'
import Heading from 'presentation/shared/components/Heading'
import SupportText from 'presentation/shared/components/SupportText'
import { useFormikContext } from 'formik'
import { EmergencyRoomEditFormikValues } from 'presentation/hospital/layouts/EmergencyRoom/EmergencyRoomDetails/types'
import Button from 'presentation/shared/components/Button'
import AutoComplete from 'presentation/shared/components/AutoComplete'
import { ReactComponent as SearchIcon } from 'presentation/assets/icons/search.svg'
import { Doctor } from 'domain/entities/doctor-model'
import { useServices } from 'presentation/hooks/use-services'

type SelectDefaultDoctorModalProps = {
  onCancel: () => void
} & WithLoadingProps

function SelectDefaultDoctorModal({ onCancel }: SelectDefaultDoctorModalProps) {
  const { values, setFieldValue, setValues } =
    useFormikContext<EmergencyRoomEditFormikValues>()

  const [doctors, setDoctors] = useState<Doctor[]>([])
  const [selectedDoctor, setSelectedDoctor] = useState<
    Partial<Doctor> | undefined
  >(values.doctor)
  const [doctorQuery, setDoctorQuery] = useState<string | undefined>(
    values.doctor?.name
  )
  const doctorService = useServices().doctor
  async function selectDoctor(doctor: Doctor) {
    if (doctor) {
      setSelectedDoctor(doctor)
      setDoctorQuery(doctor.name)
    } else {
      setSelectedDoctor(undefined)
      setDoctorQuery(undefined)
    }
  }
  const loadDoctors = async (doctorName = '') => {
    const response = await doctorService.searchDoctors({
      doctorName,
      params: ['data{', 'name', 'crm', 'crmUf', 'gender', 'doctor_id}'],
      pagination: { pageNumber: 1, pageSize: 10 }
    })
    setDoctors(response.data || [])
  }

  const handleCancel = () => {
    setValues(
      {
        ...values,
        useDefaultDoctor: undefined,
        doctor: undefined
      },
      true
    )
    onCancel()
  }

  const handleConfirm = () => {
    setFieldValue('doctor', selectedDoctor)
    onCancel()
  }

  return (
    <Modal bgColor="white">
      <S.Container>
        <Heading size="large">Buscar por médico</Heading>
        <SupportText>Buscar pelo médico usando o nome ou o CRM</SupportText>
        <S.InputButtonContainer>
          <AutoComplete
            bgColor="mainBg"
            suggestions={doctors.map((doctor) => ({
              label: `${doctor.crm}${
                doctor.crmUf ? '-' + doctor.crmUf : null
              } / ${doctor.name}`,
              value: doctor
            }))}
            name="doctor"
            placeholder="Busca por nome ou CRM"
            value={doctorQuery || ''}
            onSuggestionClick={selectDoctor}
            disabled={!!selectedDoctor}
            onType={(val) => loadDoctors(val)}
            onInputChange={setDoctorQuery}
            icon={<SearchIcon />}
            iconPosition="right"
            iconLocale="inside"
            iconMargin="54px"
            required
            data-testid="select-doctor-autocomplete"
          />
          {selectedDoctor && (
            <Button
              onClick={() => {
                setSelectedDoctor(undefined)
                setDoctorQuery('')
              }}
            >
              <SearchIcon width="30px" height="30px" viewBox="0 0 18 18" />
            </Button>
          )}
        </S.InputButtonContainer>
        <S.InputsWrapper>
          <Button variant="outlined" onClick={handleCancel}>
            Cancelar
          </Button>
          <Button onClick={handleConfirm} disabled={!selectedDoctor}>
            Confirmar
          </Button>
        </S.InputsWrapper>
      </S.Container>
    </Modal>
  )
}

export default WithLoading(SelectDefaultDoctorModal)
